<template>
	<div class="wrapper pb-3">
		<v-card
			class="ma-1 mb-3 px-4 py-3 rounded-lg d-flex flex-column justify-center align-center"
			elevation="5"
		>
			<div v-if="appType">{{ appType }}</div>
			<div
				class="grey--text text--darken-1 font-weight-bold pb-3"
				v-if="!isPrimaryDayBanner || isExecutive"
			>
				Current GMV ({{
					`${new Date(
						dd_mm_yyToyy_mm_dd(tsmTargetGmvDataStartDate)
					).toLocaleString("default", {
						day: "numeric",
						month: "short"
					})} - ${new Date(
						dd_mm_yyToyy_mm_dd(tsmTargetGmvDataEndDate)
					).toLocaleString("default", {
						day: "numeric",
						month: "short"
					})}`
				}})
			</div>
			<div
				class="grey--text text--darken-1 font-weight-bold pb-3 text-center"
				v-if="isPrimaryDayBanner && !isExecutive"
			>
				Primary Day Achievements <br />
				Recharge Value
			</div>
			<div class="d-flex justify-space-between align-center full-width">
				<div class="allCenteredChild max-w-fit-content">
					<img
						src="../../assets/orange-badge.png"
						height="56px"
						alt="orangeBadge"
						class="max-w-fit-content"
					/>
					<span class="pos-abs white--text font-weight-bold body-1">{{
						target.from
					}}</span>
				</div>
				<div class="full-width allCenteredChild">
					<div class="pos-abs pb-5 gmv-text">
						{{ tsmGmv.toLocaleString() }}
					</div>
					<div class="progress-bar">
						<div :style="`width: ${progress}%; max-width: 100%`" />
					</div>
				</div>
				<div class="allCenteredChild max-w-fit-content">
					<img
						src="../../assets/blue-badge.png"
						height="56px"
						alt="blueBadge"
						class="max-w-fit-content"
					/>
					<span class="pos-abs white--text font-weight-bold body-1">{{
						target.to
					}}</span>
				</div>
			</div>
			<div
				class="grey--text text--darken-1 body-1 font-weight-bold pt-2"
				v-if="!reward.showBottomSheet"
			>
				MONTHLY TARGET
			</div>
			<div
				class="d-flex justify-space-between align-center full-width pt-1"
				v-if="reward.showBottomSheet"
			>
				<div class="max-w-fit-content font-weight-bold">
					<div class="grey--text text--lighten-1">
						Reward
					</div>
					<div class="light-blue--text text--darken-4">
						{{ reward.from }}
					</div>
				</div>
				<div
					class="max-w-fit-content light-blue--text text--darken-3 d-flex flex-column justify-center align-center pt-3"
					@click="bottomSheet = !bottomSheet"
				>
					<div>All Incentives</div>
					<v-icon>arrow_drop_down</v-icon>
				</div>
				<div class="max-w-fit-content font-weight-bold">
					<div class="grey--text text--lighten-1">
						Reward
					</div>
					<div class="light-blue--text text--darken-4">
						{{ reward.to }}
					</div>
				</div>
			</div>
		</v-card>
		<v-bottom-sheet v-model="bottomSheet" max-width="600px">
			<v-sheet class="text-center px-4 py-3" height="auto">
				<v-btn
					fab
					flat
					class="top-right-align pa-0 ma-0"
					@click="bottomSheet = !bottomSheet"
				>
					<v-icon>close</v-icon>
				</v-btn>
				<div class="pt-4">
					<div
						class="grey--text text--darken-1 font-weight-bold pb-3"
						v-if="!isPrimaryDayBanner || isExecutive"
					>
						Current GMV
					</div>
					<div
						class="grey--text text--darken-1 font-weight-bold pb-3 text-center"
						v-if="isPrimaryDayBanner && !isExecutive"
					>
						Primary Day Achievements <br />
						Recharge Value
					</div>
					<div
						class="d-flex justify-space-between align-center full-width"
					>
						<div class="allCenteredChild max-w-fit-content">
							<img
								src="../../assets/orange-badge.png"
								height="56px"
								alt="orangeBadge"
								class="max-w-fit-content"
							/>
							<span
								class="pos-abs white--text font-weight-bold body-1"
								>{{ target.from }}</span
							>
						</div>
						<div class="full-width allCenteredChild">
							<div class="pos-abs pb-5 gmv-text">
								{{ tsmGmv.toLocaleString() }}
							</div>
							<div class="progress-bar">
								<div :style="`width: ${progress}%`" />
							</div>
						</div>
						<div class="allCenteredChild max-w-fit-content">
							<img
								src="../../assets/blue-badge.png"
								height="56px"
								alt="blueBadge"
								class="max-w-fit-content"
							/>
							<span
								class="pos-abs white--text font-weight-bold body-1"
								>{{ target.to }}</span
							>
						</div>
					</div>
					<div
						class="d-flex justify-space-between align-center full-width pt-1"
					>
						<div class="max-w-fit-content font-weight-bold">
							<div class="grey--text text--lighten-1">
								Reward
							</div>
							<div class="light-blue--text text--darken-4">
								{{ reward.from }}
							</div>
						</div>
						<div class="max-w-fit-content font-weight-bold">
							<div class="grey--text text--lighten-1">
								Reward
							</div>
							<div class="light-blue--text text--darken-4">
								{{ reward.to }}
							</div>
						</div>
					</div>
				</div>
				<div class="rounded-lg pa-3 data-table">
					<div
						class="d-flex justify-space-around align-center pa-2 table-header white--text"
					>
						<div>Target</div>
						<div>Reward</div>
					</div>
					<div
						v-for="(item, i) in tsmTargetGmvData"
						:key="i"
						class="d-flex justify-space-around align-center pa-2"
						:style="i === targetIndex ? 'background: #A4F0E2' : ''"
					>
						<div style="width: 50%">
							₹{{ item.target.toLocaleString() }}
						</div>
						<div style="width: 50%">
							{{ !isPrimaryDayBanner ? "₹" : "" }}
							{{ item.reward.toLocaleString() }}
							{{ isPrimaryDayBanner ? " %" : "" }}
						</div>
					</div>
				</div>
			</v-sheet>
		</v-bottom-sheet>
	</div>
</template>
<script>
import { getReadableAmount, dd_mm_yyToyy_mm_dd } from "../../utils";
export default {
	name: "GmvTarget",
	props: [
		"retailerId",
		"tsmGmv",
		"tsmTargetGmvData",
		"tsmTargetGmvDataStartDate",
		"tsmTargetGmvDataEndDate",
		"isPrimaryDayBanner",
		"isExecutive",
		"appType"
	],
	data() {
		return {
			target: { from: 0, to: 0 },
			reward: { from: 0, to: 0 },
			progress: 0,
			bottomSheet: false,
			targetIndex: -1,
			getReadableAmount,
			dd_mm_yyToyy_mm_dd
		};
	},
	mounted() {
		this.recalculateDetails();
	},
	methods: {
		recalculateDetails() {
			this.tsmTargetGmvData.forEach(({ target }, arrIndex) => {
				if (this.tsmGmv >= target) {
					this.targetIndex = arrIndex;
				}
			});
			const currTargetIndex =
				this.targetIndex -
				Number(this.targetIndex === this.tsmTargetGmvData.length - 1);
			this.target = {
				from:
					currTargetIndex >= 0
						? getReadableAmount(
								this.tsmTargetGmvData[currTargetIndex].target
						  )
						: 0,
				to: this.getReadableAmount(
					this.tsmTargetGmvData[currTargetIndex + 1].target
				)
			};
			const rewardFrom =
				currTargetIndex >= 0
					? this.tsmTargetGmvData[
							currTargetIndex
					  ].reward.toLocaleString()
					: 0;
			const rewardTo = this.tsmTargetGmvData[
				currTargetIndex + 1
			].reward.toLocaleString();
			this.reward = {
				from: this.isPrimaryDayBanner
					? `${rewardFrom} %`
					: `₹ ${rewardFrom}`,
				to: this.isPrimaryDayBanner ? `${rewardTo} %` : `₹ ${rewardTo}`,
				showBottomSheet: this.tsmTargetGmvData[0].reward > 0
			};
			const progressBar =
				(this.tsmGmv * 100) /
				this.tsmTargetGmvData[currTargetIndex + 1].target;
			this.progress = Math.min(progressBar, 100);
		}
	},
	watch: {
		tsmGmv() {
			this.recalculateDetails();
		}
	}
};
</script>
<style scoped>
.wrapper {
	flex-shrink: 0;
	width: 100%;
}
.rounded-lg {
	border-radius: 8px;
}
.max-w-fit-content {
	max-width: fit-content;
}
.gmv-text {
	font-size: 18px;
	font-weight: bold;
	color: #18c9b9;
}
.progress-bar {
	background-color: #e1e4ec;
	border-radius: 4px;
	width: 100%;
	margin: 0 1em;
}
.progress-bar > div {
	background: linear-gradient(90deg, #12e9b5 0%, #295cc5 100%),
		linear-gradient(270deg, #26a67b 0%, #75efc6 100%);
	height: 8px;
	border-radius: 4px;
}
.data-table > div:nth-child(odd) {
	background: #e7eaf9;
}
.data-table > div:nth-child(even) {
	background: rgba(195, 218, 254, 0.2);
}
.data-table > div:first-child {
	background: #2d4970;
	border-radius: 8px 8px 0 0;
}
.data-table > div:last-child {
	border-radius: 0 0 8px 8px;
}
</style>
